export default {
  path: ":alias/treeAdoptions",
  component: resolve => require(["@/views/tree-adoptions"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/tree-adoptions/list"], resolve)
    }
  ]
};
